var Iframe_default = {
  "iframe": "YHVN2"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
